var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45088 3.87293C8.96963 1.75543 7.12254 0.802094 5.50004 0.802094C5.50004 0.802094 5.50004 0.802094 5.49546 0.802094C3.87754 0.802094 2.02588 1.75084 1.54463 3.86834C1.00838 6.23334 2.45671 8.23626 3.76754 9.49668C4.25338 9.96418 4.87671 10.1979 5.50004 10.1979C6.12338 10.1979 6.74671 9.96418 7.22796 9.49668C8.53879 8.23626 9.98713 6.23793 9.45088 3.87293ZM5.50004 6.16918C4.70254 6.16918 4.05629 5.52293 4.05629 4.72543C4.05629 3.92793 4.70254 3.28168 5.50004 3.28168C6.29754 3.28168 6.94379 3.92793 6.94379 4.72543C6.94379 5.52293 6.29754 6.16918 5.50004 6.16918Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin2);
export default __webpack_public_path__ + "static/media/location-pin2.26735bf49ecd2027140c64e8eb47a7eb.svg";
export { ForwardRef as ReactComponent };